import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function DataDeletionPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-3xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6 gap-2">
            <ArrowLeft className="w-4 h-4" />
            Retour
          </Button>
        </Link>
        
        <h1 className="text-3xl font-bold mb-6">Suppression des Données</h1>
        
        <div className="prose prose-slate max-w-none space-y-4">
          <h2 className="text-xl font-semibold mt-6">Comment supprimer vos données</h2>
          <p>
            Pour supprimer vos données de SocialHub, suivez ces étapes :
          </p>
          
          <ol className="list-decimal pl-6 space-y-4">
            <li>
              <strong>Déconnectez vos comptes de réseaux sociaux</strong>
              <p>Allez dans Paramètres et cliquez sur "Déconnecter" pour chaque plateforme connectée.</p>
            </li>
            <li>
              <strong>Supprimez vos publications</strong>
              <p>Dans l'Historique, vous pouvez supprimer individuellement vos publications.</p>
            </li>
            <li>
              <strong>Demande de suppression complète</strong>
              <p>Pour une suppression complète de toutes vos données, contactez-nous.</p>
            </li>
          </ol>
          
          <h2 className="text-xl font-semibold mt-6">Données supprimées</h2>
          <p>
            Lors de la suppression, nous effaçons :
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Vos tokens d'accès aux réseaux sociaux</li>
            <li>L'historique de vos publications</li>
            <li>Les médias que vous avez uploadés</li>
            <li>Vos préférences et paramètres</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6">Délai de suppression</h2>
          <p>
            La suppression est effective immédiatement pour les données actives. Les sauvegardes 
            sont supprimées dans un délai de 30 jours.
          </p>
        </div>
      </div>
    </div>
  );
}
